import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import FormPage from 'pages/FormPage';
import ReservationConfirmPage from 'pages/ReservationConfirmPage';
import ReservationDetailPage from 'pages/ReservationDetailPage';
import PreviewingReservationConfirmPage from 'pages/PreviewingReservationConfirmPage';
import PreviewingReservationDetailPage from 'pages/PreviewingReservationDetailPage';
import ReservationCancelPage from 'pages/ReservationCancelPage';
import PreviewingReservationCancelPage from 'pages/PreviewingReservationCancelPage';
import CustomerIdentifyPage from 'pages/ CustomerIdentifyPage';
import ReservationQuestionnairePage from 'pages/ReservationQuestionnairePage';
import PreviewingReservationQuestionnairePage from 'pages/PreviewingReservationQuestionnairePage';
import './App.css';
import 'assets/scss/style.scss';
import Error404Page from 'pages/404Page';
import Error500Page from 'pages/500Page';
import AxiosInterceptorResponse from 'api/AxiosInterceptorResponse';

function App() {
  return (
    <Router>
      <AxiosInterceptorResponse>
        <Routes>
          <Route path="/customer-identify/:tenpoCode" element={<CustomerIdentifyPage />}></Route>
          <Route path="/form/:tenpoCode" element={<FormPage />} />
          <Route
            path="/reservation-confirm/:reservationId"
            element={<ReservationConfirmPage />}
          ></Route>
          <Route
            path="/reservation-detail/:reservationId"
            element={<ReservationDetailPage />}
          ></Route>
          <Route
            path="/previewing-reservation-confirm/:reservationId"
            element={<PreviewingReservationConfirmPage />}
          ></Route>
          <Route
            path="/previewing-reservation-detail/:reservationId"
            element={<PreviewingReservationDetailPage />}
          ></Route>
          <Route
            path="/reservation-cancel/:reservationId"
            element={<ReservationCancelPage />}
          ></Route>
          <Route
            path="/previewing-reservation-cancel/:reservationId"
            element={<PreviewingReservationCancelPage />}
          ></Route>
          <Route
            path="/reservation-questionnaire/:reservationId"
            element={<ReservationQuestionnairePage />}
          ></Route>
          <Route
            path="/previewing-reservation-questionnaire/:reservationId"
            element={<PreviewingReservationQuestionnairePage />}
          ></Route>
          <Route path="/*" element={<Error404Page />} />
          <Route path="/404" element={<Error404Page />}></Route>
          <Route path="/500" element={<Error500Page />}></Route>
        </Routes>
      </AxiosInterceptorResponse>
    </Router>
  );
}

export default App;
